import { Service, Technician, Testimonial } from "../lib/index";
import { IMAGES } from "../assets/images";

export const electronicsServices: Service[] = [
  {
    id: "tv-repair",
    title: "Smart TV & Display Repair",
    description: "Expert diagnostic and repair services for LED, OLED, QLED, and Plasma televisions. We fix screen issues, power failures, and port damages.",
    category: "electronics",
    iconName: "Tv",
    priceRange: "$80 - $450",
    features: ["Panel Replacement", "Backlight Repair", "Motherboard Service", "Software Updates"],
    onSiteAvailable: true,
    onCallAvailable: true
  },
  {
    id: "home-appliances",
    title: "Major Home Appliances",
    description: "Comprehensive repair for refrigerators, washing machines, dryers, and dishwashers. Quick fix for cooling and motor issues.",
    category: "electronics",
    iconName: "WashingMachine",
    priceRange: "$100 - $600",
    features: ["Compressor Repair", "Drum Alignment", "Seal Replacement", "Gas Refilling"],
    onSiteAvailable: true,
    onCallAvailable: true
  },
  {
    id: "music-systems",
    title: "Music & Audio Systems",
    description: "High-fidelity audio equipment repair including amplifiers, turntables, home theater systems, and professional speakers.",
    category: "electronics",
    iconName: "Music",
    priceRange: "$50 - $350",
    features: ["Circuit Refurbishment", "Speaker Recoiling", "Bluetooth Upgrades", "Remote Syncing"],
    onSiteAvailable: true,
    onCallAvailable: true
  },
  {
    id: "kitchen-gadgets",
    title: "Small Kitchen Appliances",
    description: "Repairs for microwaves, air fryers, coffee machines, and blenders to keep your kitchen running smoothly.",
    category: "electronics",
    iconName: "Microwave",
    priceRange: "$40 - $150",
    features: ["Magnetron Replacement", "Heating Element Fix", "Safety Sensor Calibration", "Motor Repair"],
    onSiteAvailable: true,
    onCallAvailable: true
  }
];

export const itServices: Service[] = [
  {
    id: "laptop-repair",
    title: "Laptop Repair & Upgrades",
    description: "Specialized repair for MacBooks and Windows laptops. Screen replacement, battery swaps, and performance boosts.",
    category: "it-support",
    iconName: "Laptop",
    priceRange: "$60 - $500",
    features: ["SSD/RAM Upgrades", "Screen Replacement", "Liquid Damage Repair", "Keyboard Fix"],
    onSiteAvailable: true,
    onCallAvailable: true
  },
  {
    id: "desktop-support",
    title: "Desktop PC Maintenance",
    description: "Hardware troubleshooting, custom PC building, and preventive maintenance for workstations and gaming rigs.",
    category: "it-support",
    iconName: "Monitor",
    priceRange: "$50 - $400",
    features: ["Thermal Pasting", "GPU Diagnostics", "PSU Replacement", "Virus Removal"],
    onSiteAvailable: true,
    onCallAvailable: true
  },
  {
    id: "internet-networking",
    title: "Internet & Network Setup",
    description: "Resolving Wi-Fi dead zones, router configuration, and setting up secure home or small office networks.",
    category: "it-support",
    iconName: "Wifi",
    priceRange: "$75 - $300",
    features: ["Mesh System Setup", "Security Hardening", "Cabling Solutions", "Speed Optimization"],
    onSiteAvailable: true,
    onCallAvailable: true
  },
  {
    id: "data-recovery",
    title: "Data Recovery & Backup",
    description: "Professional retrieval of lost data from hard drives, SSDs, and cloud configuration for future protection.",
    category: "it-support",
    iconName: "Database",
    priceRange: "$150 - $800",
    features: ["HDD/SSD Recovery", "Automated Backups", "Cloud Integration", "Secure Erase"],
    onSiteAvailable: false,
    onCallAvailable: true
  }
];

export const technicians: Technician[] = [
  {
    id: "tech-1",
    name: "David Miller",
    role: "Senior Hardware Engineer",
    specialization: ["OLED TVs", "Audio Systems", "Smart Home Hubs"],
    image: IMAGES.HERO_REPAIR_4,
    rating: 4.9,
    reviewsCount: 124,
    experienceYears: 12
  },
  {
    id: "tech-2",
    name: "Sarah Chen",
    role: "IT Systems Specialist",
    specialization: ["Data Recovery", "Network Security", "MacBook Repair"],
    image: IMAGES.CUSTOMER_SUPPORT_2,
    rating: 4.8,
    reviewsCount: 98,
    experienceYears: 8
  },
  {
    id: "tech-3",
    name: "Marcus Thorne",
    role: "Master Appliance Technician",
    specialization: ["Industrial Refrigeration", "Smart Appliances", "Diagnostics"],
    image: IMAGES.TOOLS_EQUIPMENT_1,
    rating: 4.7,
    reviewsCount: 215,
    experienceYears: 15
  }
];

export const testimonials: Testimonial[] = [
  {
    id: "test-1",
    author: "Robert J.",
    role: "Home Owner",
    content: "Fixed my 75-inch OLED TV on-site within 2 hours. The technician was extremely professional and the pricing was transparent. Highly recommended!",
    rating: 5,
    image: "https://i.pravatar.cc/150?u=robertj",
    date: "2026-01-15"
  },
  {
    id: "test-2",
    author: "Elena G.",
    role: "Graphic Designer",
    content: "My laptop wouldn't turn on during a deadline. They came to my home, diagnosed a faulty RAM, and upgraded it the same day. Saved my project!",
    rating: 5,
    image: "https://i.pravatar.cc/150?u=elenag",
    date: "2026-02-01"
  },
  {
    id: "test-3",
    author: "Kevin S.",
    role: "Small Business Owner",
    content: "Set up our entire office network and secured our servers. The ongoing IT support on call has been a game changer for our operations.",
    rating: 4,
    image: "https://i.pravatar.cc/150?u=kevins",
    date: "2026-02-10"
  }
];